// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';

import LinerLoading from '../../../assets/animations/LinerLoading';
import NoResultImage from '../../../assets/images/search-list-no-result.svg';

export const S = {
  Container: styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 70px - 90px);
    overflow: scroll;
    padding: 32px 19px 100px;

    @media only screen and (max-width: 1280px) {
      padding: 32px 10px 100px;
    }
  `,
  CardContainer: styled.div`
    display: grid;
    justify-content: center;

    grid-gap: 37px;
    grid-template-columns: repeat(4, 260px);

    @media screen and (max-width: 1670px) {
      grid-template-columns: repeat(3, 260px);
    }

    @media screen and (max-width: 1360px) {
      grid-template-columns: repeat(2, 260px);
    }

    @media screen and (max-width: 980px) {
      grid-template-columns: repeat(1, 260px);
    }
  `,
  MessageContainer: styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  NoResultImage: styled.img.attrs({ src: NoResultImage, alt: 'no-result-image' })`
    margin-bottom: 6px;
  `,
  NoResultTitle: styled.div`
    font-weight: 700;
    font-size: 24px;
    color: #434343;
    margin-bottom: 12px;
  `,
  MoreResultLoadingContainer: styled.div`
    display: flex;
    align-self: center;
    padding: 40px 0;
  `,
  MoreResultLoadingIcon: LinerLoading,
  MoreResultLoadingTitle: styled.div`
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    margin-left: 13px;
  `
};
